import _slicedToArray from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.map.js";
// Copyright 2017-2022 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { map, of } from 'rxjs';
import { BN_ZERO } from '@polkadot/util';
import { memo } from "../util/index.js";
import { filterCachedEras, getEraMultiCache, setEraMultiCache } from "./cache.js";
import { erasHistoricApply, filterEras } from "./util.js";
var CACHE_KEY = 'eraPoints';

function mapValidators(_ref) {
  var individual = _ref.individual;
  return _toConsumableArray(individual.entries()).filter(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        points = _ref3[1];

    return points.gt(BN_ZERO);
  }).reduce(function (result, _ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
        validatorId = _ref5[0],
        points = _ref5[1];

    result[validatorId.toString()] = points;
    return result;
  }, {});
}

function mapPoints(eras, points) {
  return eras.map(function (era, index) {
    return {
      era: era,
      eraPoints: points[index].total,
      validators: mapValidators(points[index])
    };
  });
}

export function _erasPoints(instanceId, api) {
  return memo(instanceId, function (eras, withActive) {
    if (!eras.length) {
      return of([]);
    }

    var cached = getEraMultiCache(CACHE_KEY, eras, withActive);
    var remaining = filterEras(eras, cached);
    return !remaining.length ? of(cached) : api.query.staking.erasRewardPoints.multi(remaining).pipe(map(function (p) {
      return filterCachedEras(eras, cached, setEraMultiCache(CACHE_KEY, withActive, mapPoints(remaining, p)));
    }));
  });
}
export var erasPoints = erasHistoricApply('_erasPoints');